import '../style/navs.css';
import Contact from "../pages/contactus";
import Footer from "../pages/footer";
import SEO from '../Component/SEO';
export default function PAgeContact(){
    return(<>
          <SEO
        title="Kontaktieren Sie uns - lamar-reinigung"
        description="Kontaktieren Sie uns für professionelle Reinigungsdienstleistungen in Karlsruhe. Wir stehen Ihnen jederzeit zur Verfügung."
        keywords="Reinigungsfirma Kontakt, Gebäudereinigung anfragen, professionelle Reinigung buchen"
        url="https://lamar-f7165.web.app/contact"
        image="https://lamar-reinigung.de/logo.png"
      />
    <div style={{height:"60px",width:"100%"}}></div>
    <Contact></Contact>
    <Footer></Footer>
    </>)
}